module.exports = __webpack_public_path__ + "images/enepi/enepi_logo_543d062b0e5f18592cd62e0163a016cf.png";